import component from './component/'
import register from '@iez/core/start/init/register/'
import router from '@iez/core/router/'
import { noop } from 'lodash'

// screens = [] (image, title, text)
export default ({ title, subtitle, screens, goTo }) => {
  const route = {
    path: '/onboarding',
    name: 'Onboarding'
  }

  /* const priority = page.setPriority({
    value: priorityValue,
    route,
    autoResolve,
    shouldAllow
  }) */

  register({
    pages: {
      Onboarding: {
        ...route,
        ...component,
        render: createElement =>
          createElement(
            component, {
              on: {
                finish: () => {
                  localStorage.setItem(`onboarding`, true)
                  router.push({
                    name: goTo ?? `Home`
                  }).catch(noop)
                }
              },
              props: {
                title,
                screens,
                subtitle
              }
            }
          )
      }
    }
  })
}
